import type {useLocation} from 'react-router'
import {HttpError} from '@freckle/educator-entities/ts/common/exceptions/http-error'
import {GoogleAnalytics} from '@freckle/educator-entities/ts/common/helpers/analytics'
import {logErrorAsUnhandled} from '@freckle/school/ts/common/helpers/exception-handlers/bugsnag-client'

type Location = ReturnType<typeof useLocation>

function trackSchoolRouteChanges(location: Location): Promise<unknown> {
  return GoogleAnalytics.trackRouteChange(location.pathname).catch(err =>
    logErrorAsUnhandled(new HttpError(err)),
  )
}

export default {
  trackSchoolRouteChanges,
}
